import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-coins-svg-icon',
    templateUrl: 'duotone-coins-svg-icon.component.html',
    standalone: false
})

export class DuotoneCoinsSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
